import { 
  getProductsDropDown,
  getStoreSettings,
  getStoreDetails,
  getPublicHolidayList,
  getCoaList,
  getAllCustomers,
  getLedgerDetails,
  getSuppliers,
  getSizes,
  getColours,
  getBrands,
  getHSNs,
  getTaxes,
  getUnits,
  getManufacturers,
  getCategoryAndSubCategory
 } from "helpers/backend_helper"

const getStoreId=()=>{
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    if(obj.storeid){
      return obj.storeid
    }
    else {
      return "NA"
    }
  }
  return "NA"
}

export const storeLastDraftPurchase = (link) => { 
  localStorage.setItem(getStoreId()+'-LP-Draft',JSON.stringify({
    link : link
  })
  )
}

export const removeLastDraftPurchase = () => {
  localStorage.removeItem(getStoreId()+'-LP-Draft')
}

export const getLastDraftPurchase = () => { 
  let jsonResp = localStorage.getItem(getStoreId()+'-LP-Draft')
  if(jsonResp){
    return JSON.parse(jsonResp)
  }
  else{
    return null
  }
}

export const getProductsDropDownFromCache = async (fromcache) => { 
    
    if(fromcache){
      let jsonResp = localStorage.getItem(getStoreId()+'Product')
      //console.log('jsonResp:'+jsonResp)
      if(jsonResp){
        return JSON.parse(jsonResp)
      }
    }
    const resp = await getProductsDropDown()
    //console.log('resp from server:'+resp)
    if(resp){
      localStorage.setItem(getStoreId()+'Product',JSON.stringify(resp))
      return resp
    }
    else{
      return null
    }
}

export const getStoreSettingsFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Settings')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getStoreSettings()
  if(resp){
    localStorage.setItem(getStoreId()+'Settings',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getStoreDetailsFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'StoreDetails')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getStoreDetails()
  if(resp){
    localStorage.setItem(getStoreId()+'StoreDetails',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getPublicHolidayListFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'PHoliday')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getPublicHolidayList({})
  if(resp && resp.length > 0){
    localStorage.setItem(getStoreId()+'PHoliday',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getCOAListFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'COA')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getCoaList({})
  if(resp && resp.length > 0){
    localStorage.setItem(getStoreId()+'COA',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getAllCustomersFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Customer')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getAllCustomers({})
  if(resp && resp.length > 0){
    localStorage.setItem(getStoreId()+'Customer',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getLedgerDetailsFromCache = async (type, fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Ledger'+type.inputKey)
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getLedgerDetails(type)
  if(resp && resp.length > 0){
    localStorage.setItem(getStoreId()+'Ledger'+type.inputKey,JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getSuppliersFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Supplier')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getSuppliers({})
  if(resp && resp.length > 0){
    localStorage.setItem(getStoreId()+'Supplier',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getSizesFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Size')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getSizes({})
  if(resp){
    localStorage.setItem(getStoreId()+'Size',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getColoursFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Colour')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getColours({})
  if(resp){
    localStorage.setItem(getStoreId()+'Colour',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getBrandsFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Brand')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getBrands({})
  if(resp){
    localStorage.setItem(getStoreId()+'Brand',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}

export const getHSNsFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'HSN')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getHSNs({})
  if(resp){
    localStorage.setItem(getStoreId()+'HSN',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}
export const getTaxesFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Tax')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getTaxes({})
  if(resp){
    localStorage.setItem(getStoreId()+'Tax',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}
export const getUnitsFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Unit')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getUnits({})
  if(resp){
    localStorage.setItem(getStoreId()+'Unit',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}
export const getManufacturersFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Manufacturer')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getManufacturers({})
  if(resp){
    localStorage.setItem(getStoreId()+'Manufacturer',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}
export const getCategoryAndSubCategoryFromCache = async (fromcache) => {
  if(fromcache){
    let jsonResp = localStorage.getItem(getStoreId()+'Category')
    if(jsonResp){
      return JSON.parse(jsonResp)
    }
  }
  const resp = await getCategoryAndSubCategory({})
  if(resp){
    localStorage.setItem(getStoreId()+'Category',JSON.stringify(resp))
    return resp
  }
  else{
    return null
  }
}


export const clearLocalCache = async(key) => {
  if(key && key != ''){
    localStorage.removeItem(key)
  }
  else{
    localStorage.removeItem(getStoreId()+'Category')
    localStorage.removeItem(getStoreId()+'Manufacturer')
    localStorage.removeItem(getStoreId()+'Unit')
    localStorage.removeItem(getStoreId()+'Tax')
    localStorage.removeItem(getStoreId()+'HSN')
    localStorage.removeItem(getStoreId()+'Brand')
    localStorage.removeItem(getStoreId()+'Colour')
    localStorage.removeItem(getStoreId()+'Size')
    localStorage.removeItem(getStoreId()+'Supplier')
    localStorage.removeItem(getStoreId()+'Customer')
    localStorage.removeItem(getStoreId()+'COA')
    localStorage.removeItem(getStoreId()+'PHoliday')
    localStorage.removeItem(getStoreId()+'StoreDetails')
    localStorage.removeItem(getStoreId()+'Product')
    localStorage.removeItem(getStoreId()+'Settings')
    
    let allkeys = Object.keys(localStorage)
    allkeys.map(each =>{
      //console.log('each:::'+each)
      if(each.startsWith(getStoreId()+'Ledger') || each.startsWith(getStoreId()+'masterData_')){
        localStorage.removeItem(each)
      }
    })
  }
}
